export const CONSENT_KEY = "revexia_cookie_consent";
export const POLICY_VERSION = "1.0";

export function getConsent() {
  try {
    const storedConsent = localStorage.getItem(CONSENT_KEY);

    if (!storedConsent) {
      return null;
    }

    return JSON.parse(storedConsent);
  } catch (error) {
    console.error("Could not read cookie consent:", error);
    return null;
  }
}

export function hasConsent(category) {
  const consent = getConsent();

  if (!consent) {
    return category === "essential";
  }

  if (category === "essential") {
    return true;
  }

  return consent[category] === true;
}

/**
 * Notify the application that the visitor changed
 * their cookie consent preferences.
 */
export function notifyConsentChange(consent) {
  window.dispatchEvent(
    new CustomEvent("revexiaConsentUpdated", {
      detail: consent,
    })
  );
}

/**
 * Subscribe to consent changes.
 *
 * Returns a cleanup function so React components can
 * remove the listener when they unmount.
 */
export function onConsentChange(callback) {
  const handler = (event) => {
    callback(event.detail);
  };

  window.addEventListener("revexiaConsentUpdated", handler);

  return () => {
    window.removeEventListener("revexiaConsentUpdated", handler);
  };
}